// extracted by mini-css-extract-plugin
module.exports = {"message":"InactiveProductWarning_message__tBl6t"};